module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-standside-1400.42ba9ff2.svg";